module.exports = __webpack_public_path__ + "img/landing.d53d9061.webp";